import { theme } from "twin.macro";

const size = {
  sm: theme("screens.sm"),
  md: theme("screens.md"),
  lg: theme("screens.lg"),
  xl: theme("screens.xl"),
  xxl: theme("screens.2xl"),
};

export const screen = {
  sm: `@media (min-width: ${size.sm})`,
  md: `@media (min-width: ${size.md})`,
  lg: `@media (min-width: ${size.lg})`,
  xl: `@media (min-width: ${size.xl})`,
  xxl: `@media (min-width: ${size.xxl})`,
};

export type Breakpoint = "sm" | "md" | "lg" | "xl" | "xxl";

// 0.02px below the breakpoint so these never overlap the min-width queries.
const below = (value: string): string => `${parseFloat(value) - 0.02}px`;

export const screenBelow: Record<Breakpoint, string> = {
  sm: `@media (max-width: ${below(size.sm)})`,
  md: `@media (max-width: ${below(size.md)})`,
  lg: `@media (max-width: ${below(size.lg)})`,
  xl: `@media (max-width: ${below(size.xl)})`,
  xxl: `@media (max-width: ${below(size.xxl)})`,
};
